import { render, staticRenderFns } from "./SchulteGrid.vue?vue&type=template&id=4a663121"
import script from "./SchulteGrid.vue?vue&type=script&lang=js"
export * from "./SchulteGrid.vue?vue&type=script&lang=js"
import style0 from "./SchulteGrid.vue?vue&type=style&index=0&id=4a663121&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports